import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteGuard } from '../../shared/guards/route.guard';
import { BeforeYouStartComponent } from './before-you-start.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: BeforeYouStartComponent,
    canActivate: [RouteGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BeforeYouStartRoutingModule { }
